import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3e3635"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-tool-item" }
const _hoisted_2 = ["src", "alt"]

import { researchToolInfos } from '@/rd/ResearchTools'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchToolItem',
  props: {
    toolId: {}
  },
  setup(__props: any) {

const props = __props;



const toolInfoRef = computed(() => researchToolInfos.find(t => t.id == props.toolId))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: toolInfoRef.value?.icon,
      alt: toolInfoRef.value?.name
    }, null, 8, _hoisted_2),
    _createTextVNode(" " + _toDisplayString(toolInfoRef.value?.name), 1)
  ]))
}
}

})